import { parseNumeric } from '../../../shared/utils';

type TransitionPredicate = (currentStatus: number | null, previousStatus: number | null) => boolean;

type TransitionParams = {
  editedRows: Array<Record<string, any>>;
  editedRowsOriginal: { [id: string]: Record<string, any> };
};

/**
 * Generic helper to filter rows based on a specific transition of the `erledigt_me` status.
 */
function filterRowsByMeDoneTransition(
  params: TransitionParams & { predicate: TransitionPredicate },
) {
  const currentRows = params.editedRows || [];

  return currentRows.filter((row) => {
    const rowId = row?.id1;
    const originalRow = params.editedRowsOriginal?.[rowId];

    if (!originalRow) return false;

    const currentStatus = parseNumeric(row?.erledigt_me);
    const previousStatus = parseNumeric(originalRow?.erledigt_me);

    return params.predicate(currentStatus, previousStatus);
  });
}

/**
 * Detects rows that have just been changed to "Done" (erledigt_me).
 */
export function getRowsTransitionedToMeDoneYes(
  params: TransitionParams & { meDoneYesId: number },
) {
  return filterRowsByMeDoneTransition({
    editedRows: params.editedRows,
    editedRowsOriginal: params.editedRowsOriginal,
    predicate: (currentStatus, previousStatus) =>
      currentStatus === params.meDoneYesId && previousStatus !== params.meDoneYesId,
  });
}

/**
 * Detects rows that have just been changed from "Done" to "No" (erledigt_me).
 */
export function getRowsTransitionedToMeDoneNo(
  params: TransitionParams & { meDoneYesId: number; meDoneNoId: number },
) {
  return filterRowsByMeDoneTransition({
    editedRows: params.editedRows,
    editedRowsOriginal: params.editedRowsOriginal,
    predicate: (currentStatus, previousStatus) =>
      currentStatus === params.meDoneNoId && previousStatus === params.meDoneYesId,
  });
}